<div class="layout-footer">
    <span class="font-medium ml-2">SRM Portal</span>
</div>
